(() => {
  if (window.AlankruthaProductStickyInitialized) return;
  window.AlankruthaProductStickyInitialized = true;

  const syncBars = () => {
    document.querySelectorAll('[data-product-sticky]').forEach((bar) => {
      const section = bar.closest('product-info');
      const primary = section?.querySelector('.product-form__submit');
      const stickyButton = bar.querySelector('[data-sticky-add]');
      if (!primary || !stickyButton) return;
      const isDisabled = primary.disabled || primary.getAttribute('aria-disabled') === 'true';
      const buttonText = primary.querySelector('span')?.textContent.trim() || primary.textContent.trim();
      if (stickyButton.disabled !== isDisabled) stickyButton.disabled = isDisabled;
      if (stickyButton.textContent.trim() !== buttonText) stickyButton.textContent = buttonText;
    });
  };

  const updateVisibility = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('[data-product-sticky]').forEach((bar) => {
      const section = bar.closest('product-info');
      const primary = section?.querySelector('.product-form__submit');
      const sectionRect = section?.getBoundingClientRect();
      if (!primary || !sectionRect) return;
      const primaryRect = primary.getBoundingClientRect();
      const show = primaryRect.bottom < 0 && sectionRect.bottom > window.innerHeight;
      bar.classList.toggle('is-visible', show);
    });
  };

  document.addEventListener('click', (event) => {
    const stickyButton = event.target.closest('[data-sticky-add]');
    if (!stickyButton) return;
    const primary = stickyButton.closest('product-info')?.querySelector('.product-form__submit');
    if (primary && !primary.disabled) primary.click();
  });

  const initialize = () => {
    syncBars();
    updateVisibility();
    document.querySelectorAll('product-info .product-form__submit').forEach((primary) => {
      new MutationObserver(() => {
        syncBars();
        updateVisibility();
      }).observe(primary, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('change', () => requestAnimationFrame(syncBars));
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility, { passive: true });
})();
